<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>

          <!-- LEFT : DYEING MASTER -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Purchase Order Info
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense class="mt-3">

                    <v-col cols="12" md="3">
                        <v-date-input
                            input-format="dd/mm/yyyy"
                            label="Invoice Date*"
                            v-model="invoice_date"
                            :error-messages="errors.invoice_date"
                            variant="outlined"
                            density="compact"
                            prepend-icon=""
                            clearable
                        />

                    </v-col>

                    <v-col cols="12" md="3">
                        <v-date-input
                            input-format="dd/mm/yyyy"
                            label="Shipment Date*"
                            v-model="shipment_date"
                            :error-messages="errors.shipment_date"
                            variant="outlined"
                            density="compact"
                            prepend-icon=""
                            clearable
                        />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Contract No*"
                        v-model="contact_no"
                        :error-messages="errors.contact_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Master sales Contract No*"
                        v-model="master_sales_contact_no"
                        :error-messages="errors.master_sales_contact_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Season*"
                        v-model="season"
                        :error-messages="errors.season"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Purchase Order No*"
                        v-model="purchase_order_no"
                        :error-messages="errors.purchase_order_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        type="number"
                        label="Total Amount*"
                        v-model="total_amount"
                        :error-messages="errors.total_amount"
                        density="compact"
                        variant="outlined"
                        readonly=""
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Currency*"
                        v-model="currency_id"
                        :items="currencyList"
                        :item-title="item => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="errors.currency_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Buyer*"
                        v-model="buyer_id"
                        :items="getCustomerMapList"
                        :item-title="item => `${item.customer?.company_name ?? ''} - ${item.customer?.code ?? ''}`"
                        :item-value="item => item.customer?.id ?? null"
                        :error-messages="errors.buyer_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Shipment Method*"
                        v-model="shipping_method_id"
                        :items="getShippingMethodList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.shipping_method_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Shipment From"
                        v-model="from_shipment"
                        :items="portList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.from_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Shipment To"
                        v-model="to_shipment"
                        :items="portList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.to_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>


                    <v-col cols="12" md="3">
                        <v-select
                            label="Early Shipment*"
                            v-model="early_shipment"
                            :items="[
                                { label: 'Allowed', value: 'allowed' },
                                { label: 'Not Allowed', value: 'not_allowed' }
                            ]"
                            item-title="label"
                            item-value="value"
                            :error-messages="errors.early_shipment"
                            density="compact"
                            variant="outlined"
                            clearable
                        />
                    </v-col>


                    <v-col cols="12" md="3">
                        <v-select
                            label="Transhipment*"
                            v-model="transhipment"
                            :items="[
                                { label: 'Allowed', value: 'allowed' },
                                { label: 'Not Allowed', value: 'not_allowed' }
                            ]"
                            item-title="label"
                            item-value="value"
                            :error-messages="errors.transhipment"
                            density="compact"
                            variant="outlined"
                            clearable
                        />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                      type="number"
                        label="Short Excess Tolerance*"
                        v-model="short_excess_tolerance"
                        :error-messages="errors.short_excess_tolerance"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        type="text"
                        label="Composition"
                        v-model="composition"
                        :error-messages="errors.composition"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- RIGHT : DYEING BREAKDOWN -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card flat>
                    <v-card-text style="overflow-y: auto; white-space: nowrap;">

                        <table class="dep-table order-table mt-4 custome-table">
                            <thead>
                                <tr>
                                    <th class="table-header-cel" v-for="col in headers" :key="col.value">{{ col.text }}</th>
                                    <th class="table-header-cel">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(row, rowIndex) in tableData" :key="row.id" :class="{ 'error-row': tableErrors[rowIndex] }">
                                    <td v-for="(col, colIndex) in headers" :key="col.value" :class="{ 'error-td': (tableErrors[rowIndex]?.[col.value]) }">
                                        <v-text-field
                                            v-if="!['total_amount','quantity','unit_price','currency_id'].includes(col.value)"
                                            style="min-width:150px;"
                                            type="text"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                        />

                                        <v-text-field
                                            style="min-width:100px;"
                                            v-if="['quantity','unit_price'].includes(col.value)"
                                            type="number"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                                            @update:model-value="calculateTotalValue(rowIndex)"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                        />
                                        <v-text-field
                                            style="min-width:100px;"
                                            v-if="['total_amount'].includes(col.value)"
                                            type="number"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            readonly=""
                                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                        />
                                        <v-autocomplete
                                          style="height: 32px !important; min-width:100px;"
                                          v-if="['currency_id'].includes(col.value)"
                                          class="breakdown-input"
                                          v-model="row[col.value]"
                                          :items="currencyList"
                                          :item-title="item => `${item.code} - ${item.name}`"
                                          item-value="id"
                                          density="compact"
                                          variant="outlined"
                                        />
                                    </td>
                                    <td style="width:65px;">
                                        <v-btn v-if=" (rowIndex != tableData.length - 1) || (tableData.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeRow(rowIndex)">
                                            <v-icon color="red">mdi-close</v-icon>
                                        </v-btn>

                                        <v-btn v-if="rowIndex == tableData.length - 1" variant="tonal" icon size="small" color="primary" class=" breakdown-input" @click="addRow">
                                            <v-icon color="blue">mdi-plus</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                      <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
    import { ref, reactive, nextTick, onMounted, computed } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { toast } from "vue3-toastify";
    import { useStore } from "vuex";
    import * as yup from "yup";
    import formattedDate from "@/plugins/dateFormatter";

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const updateId = route.params.id;

    const headers = [
        { text: "Color", value: "color" },
        { text: "Size", value: "size" },
        { text: "Composition", value: "composition" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit price", value: "unit_price" },
        { text: "Total Amount", value: "total_amount" },
        { text: "Currency", value: "currency_id" },
    ];

    const panel = ref([0]);
    const panel1 = ref([0]);
    const isEdit = ref(false);

    const invoice_date = ref(null);
    const shipment_date = ref(null);
    const contact_no = ref("");
    const master_sales_contact_no = ref("");
    const season = ref("");
    const total_amount = ref(0);
    const purchase_order_no = ref("");
    const buyer_id = ref(null);
    const currency_id = ref(null);
    const shipping_method_id = ref(null);
    const from_shipment = ref(null);
    const to_shipment = ref(null);
    const early_shipment = ref(null);
    const transhipment = ref(null);
    const short_excess_tolerance = ref("");
    const composition = ref("");
    const tableData = reactive([]);
    const errors = reactive({});
    const tableErrors = reactive({});

    const getCustomerMapList = ref([]);
    const getSupplierList = ref([]);
    const getShippingMethodList = ref([]);
    const currencyList = ref([]);

    const portList = computed(() => store.getters.getLcPortList || []);

    async function getInitialData() {

      store.commit("SET_LOADING", { color: "primary" });
      const purchaseOrder = updateId ? await store.dispatch("getBhpPurchaseOrderById", { id: updateId }) : null;
      const customerMapList    = await store.dispatch('getCustomerMapList');
      const supplierList       = await store.dispatch('getSupplierList');
      const shippingMethodList = await store.dispatch('getLcShippingMethodList');
      const currencyListRes = await store.dispatch("getCurrencyList");
      if (store.getters.getLcPortList.length === 0) { await store.dispatch("getLcPortList");}
      store.commit("UNSET_LOADING");

      getCustomerMapList.value = customerMapList.data.data;
      getSupplierList.value = supplierList.data.data;
      getShippingMethodList.value = shippingMethodList.data.data;
      currencyList.value = currencyListRes.data.currency;

      if(updateId){
        isEdit.value = true;

        const data = purchaseOrder.data.data;
        invoice_date.value = data.invoice_date;
        shipment_date.value = data.shipment_date;
        contact_no.value = data.contact_no;
        master_sales_contact_no.value = data.master_sales_contact_no;
        season.value = data.season;
        purchase_order_no.value = data.purchase_order_no;
        buyer_id.value = data.buyer_id;
        currency_id.value = data.currency_id;
        shipping_method_id.value = data.shipping_method_id;
        from_shipment.value = data.from_shipment;
        to_shipment.value = data.to_shipment;
        early_shipment.value = data.early_shipment;
        transhipment.value = data.transhipment;
        short_excess_tolerance.value = data.short_excess_tolerance;
        composition.value = data.composition;
        total_amount.value = data.total_amount;

        tableData.splice(0); 
        data.details.forEach((d, index) => {
            tableData.push({
                id: index + 1,
                color: d.color,
                size: d.size,
                composition:d.composition,
                quantity: d.quantity,
                unit_price: d.unit_price,
                total_amount: d.total_amount,
                currency_id:d.currency_id,
            });
        });
      }
      if (!tableData.length) addRow();
    }

    function addRow() {
      const newId = tableData.length ? tableData[tableData.length - 1].id + 1 : 1;
      const row = { id: newId };
      headers.forEach(h => (
        h.value == 'currency_id' ? row[h.value] = null : row[h.value] = ""
      ));
      tableData.push(row);
      nextTick(() => focusCell(tableData.length - 1, 0));
    }

    function removeRow(index){
      if (tableData.length > 1) {
          tableData.splice(index, 1);
      }

      const newErrors = {};
      tableData.forEach((_, i) => {
          if (tableErrors[i]) {
            newErrors[i] = tableErrors[i];
          }
      });

      Object.keys(tableErrors).forEach(k => delete tableErrors[k]);
      Object.assign(tableErrors, newErrors);
    }

    function focusNextCell(rowIndex, colIndex) {
      const totalRows = tableData.length;
      const totalCols = headers.length;
      let nextRow = rowIndex;
      let nextCol = colIndex + 1;

      if (nextCol >= totalCols) {
          nextCol = 0;
          nextRow++;
          if (nextRow >= totalRows) {
              addRow();
              nextRow = totalRows;
          }
      }
      focusCell(nextRow, nextCol);
    }

    function focusCell(rowIndex, colIndex) {
      nextTick(() => {
          const table = document.querySelector("table");
          const row = table?.rows[rowIndex + 1];
          if (row) {
            const cell = row.cells[colIndex]?.querySelector("input");
            if (cell) cell.focus();
          }
      });
    }


    function calculateTotalValue(rowIndex){
        tableData[rowIndex].total_amount = tableData[rowIndex].unit_price * tableData[rowIndex].quantity;
        var grandTotal = 0;
        for (let i = 0; i < tableData.length; i++) {
          grandTotal += tableData[i]?.total_amount ?? 0;
        }
        total_amount.value = grandTotal;
    }


    const detailsSchema = yup.object({
      color: yup.string().required("Color required"),
      size: yup.string().required("Size required"),
      quantity: yup.number().typeError("Quantity must be number").required().positive(),
      unit_price: yup.number().typeError("Unit price must be number").required().min(0),
      total_amount: yup.number().typeError("Total amount must be number").required(),
    });

    const schema = yup.object({
        invoice_date: yup.date().required("Order date required"),
        shipment_date: yup.date().required("Shipment date required"),
        contact_no: yup.string().required(),
        master_sales_contact_no: yup.string().required(),
        season: yup.string().required(),
        purchase_order_no: yup.string().required(),
        buyer_id: yup.number().required(),
        shipping_method_id: yup.number().required(),
        from_shipment: yup.number().required(),
        to_shipment: yup.number().required(),
        early_shipment: yup.string().nullable(),
        transhipment: yup.string().nullable(),
        short_excess_tolerance: yup.number().required(),
        total_amount: yup.number().required(),

        details: yup.array().of(detailsSchema).min(1),
    });

    async function submitForm(status) {
        Object.keys(errors).forEach(k => delete errors[k]);
        Object.keys(tableErrors).forEach(k => delete tableErrors[k]);

        const payload = {
            invoice_date: formattedDate(invoice_date.value),
            shipment_date: formattedDate(shipment_date.value),
            contact_no: contact_no.value,
            master_sales_contact_no:master_sales_contact_no.value,
            season: season.value,
            total_amount: total_amount.value,
            purchase_order_no: purchase_order_no.value,
            buyer_id: buyer_id.value,
            currency_id: currency_id.value,
            shipping_method_id: shipping_method_id.value,
            from_shipment: from_shipment.value,
            to_shipment: to_shipment.value,
            early_shipment: early_shipment.value,
            transhipment: transhipment.value,
            short_excess_tolerance: short_excess_tolerance.value,
            composition:composition.value,
            status,
            details: tableData,
        };

        try {
            await schema.validate(payload, { abortEarly: false });
            if(isEdit.value) {
                await store.dispatch("updateBhpPurchaseOrder", { id: updateId, data: payload }).then((res) => {
                    if(!res.data.success){
                        toast.error(res.data.message);
                    }else{
                        toast.success("Saved Successfully");
                        router.push({ name: "purchase-order-record" });
                    }
                 });
            } else {
                await store.dispatch("saveBhpPurchaseOrder", payload).then((res) => {
                    if(!res.data.success){
                        toast.error(res.data.message);
                    }else{
                        toast.success("Saved Successfully");
                        router.push({ name: "purchase-order-record" });
                    }
                 });
            }
            
        } catch(err) {
            err.inner.forEach(e => {
                if (e.path && e.path.startsWith("details")) {
                    const match = e.path.match(/details\[(\d+)\]\.(.+)/);
                    if (match) {
                        const rowIndex = match[1];
                        const field = match[2];

                        if (!tableErrors[rowIndex]) tableErrors[rowIndex] = {};
                        tableErrors[rowIndex][field] = e.message;
                    }
                } else {
                    errors[e.path] = e.message;
                }
            });
        }
    }

    onMounted(getInitialData);
</script>

<style>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}

.breakdown-input .v-field {
  min-height: 32px !important;
  height: 32px !important;
  border:none !important;
  border-radius: 0px !important;
}

.breakdown-input .v-field .v-field__input {
  min-height: 32px !important; 
  height: 32px !important;
  padding: 2 !important;
  font-size: 12px;
}

.breakdown-input input{
    min-height: 32px !important; 
  height: 32px !important;
  max-height: 32px !important;
}


.custome-table {
    width: 100% !important;
    border-collapse: collapse;
}

.custome-table th,
.custome-table td {
    border: 1px solid #c0c0c0;
    text-align: left; 
}

.custome-table th {
    background-color: #eceff1; 
    font-weight: 600;
}
.table-header-cel{
    text-align: center !important;
    height: 30px;
    font-size: 12px;
}

.v-btn--icon{
  height: 30px !important;
  width: 30px !important;
}
.error-row {
  /* background: #fff3f3; */
}
.error-td{
  border-color: red !important;
}

</style>
